import React from "react";
import ReactGA from 'react-ga4'
import { useLocation } from "react-router-dom";
import request from "../../utilities/requests";
import Layout from "../../components/Layout";
import { Grid } from "@mui/material";

import ProfileHeader from "./components/ProfileHeader";
import ProfileBody from "./components/ProfileBody";
import ProfileTour from "./components/ProfileTour";
import FirstLoginDialog from "./components/FirstLoginDialog";

const Profile = () => {
  const location = useLocation();
  const profileTour = location.state?.profileTour;

  const [profile, setProfile] = React.useState({});
  const [fields, setFields ] = React.useState({})
  const [loaded, setLoaded] = React.useState(false);
  const [firstLoginOpen, setFirstLoginOpen] = React.useState(false);
  const [tourActive, setTourActive] = React.useState(Boolean(profileTour));

  const tourSteps = React.useMemo(() => {
    if (!profileTour) return [];
    const steps = [];
    if (profileTour.questionGroupId) {
      steps.push({
        selector: '[data-tour="event-profile"]',
        title: "Finish your event profile",
        body: `Tap "${profileTour.questionGroupName || "your event profile"}" to answer the remaining questions.`,
      });
    }
    if (profileTour.name) {
      steps.push({
        selector: '[data-tour="profile-name"]',
        title: "Add your name",
        body: "Tap the pencil to add your first and last name.",
      });
    }
    if (profileTour.photo) {
      steps.push({
        selector: '[data-tour="profile-photo"]',
        title: "Add a profile photo",
        body: "Tap here to upload your profile picture.",
      });
    }
    return steps;
  }, [profileTour]);

  React.useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/profile", title: "Profile" });
  },[])

  React.useEffect(() => {
    if (!loaded) {
      getProfile();
      setLoaded(true);
    }
  });

  React.useEffect(() => {
    if (profile.firstLogin === true) {
      console.log('first login')
      setFirstLoginOpen(true);
    }
  },[profile])

  const getProfile = async () => {
    const result = await request("profile");
    if (result.success) {
      setProfile(result.profile);
      setFields(result.fields)
    }
  };

  const handleClose = async () => {

    setFirstLoginOpen(false)
    const body = {
      firstLogin: false
    }
    const result = await request("profile/update", "post", body);
    
  }

  return (
    <Layout>
      <ProfileHeader profile={profile} refresh={getProfile}/>
      <Grid container direction="column" spacing={3} alignItems="center">
        <ProfileBody
          profile={profile}
          fields={fields}
          refresh={getProfile}
          tourQuestionGroupId={profileTour?.questionGroupId}
        />
        <FirstLoginDialog open={firstLoginOpen} close={handleClose} />
      </Grid>
      {tourActive && tourSteps.length > 0 && (
        <ProfileTour steps={tourSteps} onFinish={() => setTourActive(false)} />
      )}
    </Layout>
  );
};

export default Profile;
